import React, { Component } from 'react';
import styled, { css, withTheme } from 'styled-components';
import { Transition } from 'react-transition-group';
import {
  ENTERING,
  ENTERED,
  EXITING,
  EXITED,
} from 'react-transition-group/Transition';
import { withRouter } from 'react-router-dom';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';
import PageLoadingOverlay from './PageLoadingOverlay';
import RouterStore from "../flux/RouterStore";
import Dispatcher from "../flux/Dispatcher";
import ActionTypes from "../flux/ActionTypes";

const TRANSITION_TIMEOUT_MOBILE = 0;
const TRANSITION_TIMEOUT_TABLET = 200;

class ModalFullscreen extends Component {

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // @todo: Try with the flux waitFor method
      setTimeout(() => {
        Dispatcher.dispatch({
          actionType: ActionTypes.ROUTER_MODAL_NAVIGATE,
          url: this.props.location.pathname
        });
      }, 0);
    }
  }

  componentWillUnmount() {
    Dispatcher.dispatch({
      actionType: ActionTypes.ROUTER_MODAL_NAVIGATE,
      url: null
    });
  }

  render() {
    return (
      <Transition
        in={this.props.isOpen}
        timeout={themeResponsiveProperty(TRANSITION_TIMEOUT_MOBILE, TRANSITION_TIMEOUT_TABLET)(this.props)}
      >
        {state => (
          <Container state={state}>
            <ContainerInner>
              <PageLoadingOverlay visible={this.props.isLoading} />

              {this.props.isOpen !== null ? (
                // @todo 2021-06-08
                //   should not check for isVisible otherwise the close animation
                //   does not work as expected.

                this.props.children
              ) : null}
            </ContainerInner>
          </Container>
        )}
      </Transition>
    )
  }
}

export default withTheme(withRouter(ModalFullscreen));

const Container = styled.div`
  z-index: 108; // Header is 99 and TabBar is 109
  position: fixed;
  top: 0;
  right: 0;
  // 4.625rem is the TabBar height
  bottom: ${themeResponsiveProperty('4.625rem', 0)};
  left: 0;
  background-size: 8.125rem 2.1875rem;
  background-color: ${props => props.theme.primaryBackgroundColor};
  transition: all ${themeResponsiveProperty(TRANSITION_TIMEOUT_MOBILE, TRANSITION_TIMEOUT_TABLET)}ms ease;
  transform: translateY(10%);
  opacity: 0;

  // If there are nested ModalFullscreen (it can happen in a complex navigation,
  // for example for report modals) we make sure the bottom spacing is correct.
  & & {
    bottom: 0;
  }

  ${({ state }) => {
    switch (state) {
      case ENTERING:
        return css`
          display: block;
          will-change: transform, opacity;
        `;

      case ENTERED:
        return css`
          transform: translateY(0);
          opacity: 1;
          will-change: transform, opacity;
        `;

      case EXITING:
        return css`
          transform: translateY(10%);
          opacity: 0;
          will-change: transform, opacity;
        `;

      default:
      case EXITED:
        return css`display: none;`;
    }
  }}
`;

const ContainerInner = styled.div`
  display: flex;
  flex-direction: column;

  // Will trap any fixed-positioned element. This is useful to prevent those
  // elements from covering the header.
  transform: translate(0,0);
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
`;
